import { msgTime } from "./index";
import { getChatListReadReceiptFromRoom } from "./chatListReadReceipt";

export function assignedToHasAssignee(assignedTo) {
  if (assignedTo == null) return false;
  if (typeof assignedTo === "object") {
    return !!(assignedTo._id || assignedTo.id);
  }
  return true;
}

export function socketPayloadIsUnassignedChat(room) {
  if (!room) return false;
  if (room.is_unAssigned === true) return true;
  if (room.is_unAssigned === false) return false;
  return !assignedToHasAssignee(room.assigned_to);
}

function formatChatStartedTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  const hours = date.getHours();
  const minutes = `0${date.getMinutes()}`.slice(-2);
  const amOrPm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  return `${year}-${month}-${day} ${formattedHours}:${minutes} ${amOrPm}`;
}

/**
 * Map a socket `room-created-notification` payload to the same row shape as
 * `ListAllRoomsApi` → unassigned list in UnAssignedRooms (users may be ids only).
 */
export function transformSocketRoomToUnassignedListRow(newRoom, loggedInAgentId) {
  if (!newRoom?._id) return null;
  const users = Array.isArray(newRoom.users) ? newRoom.users : [];
  const userObjects = users.filter((u) => typeof u === "object" && u !== null);

  const customerUser =
    userObjects.length > 0
      ? userObjects.find(
          (u) => u?._id && u?._id !== loggedInAgentId && u?.is_guest
        ) ||
        userObjects.find((u) => u?._id && u?._id !== loggedInAgentId) ||
        userObjects[0]
      : null;

  const snap = newRoom.latestMessageSnapshot;
  const latest = newRoom.latestMessage;
  const latestTime =
    snap?.createdAt ||
    latest?.createdAt ||
    newRoom.updatedAt ||
    newRoom.createdAt;

  const roomUserIds = users
    .map((u) =>
      typeof u === "object" && u?._id ? u._id : typeof u === "string" ? u : null
    )
    .filter(Boolean);

  const visitorIdFromIds =
    roomUserIds.find((id) => String(id) !== String(loggedInAgentId || "")) ||
    (roomUserIds.length === 1 ? roomUserIds[0] : null) ||
    null;

  return {
    id: newRoom._id,
    title: newRoom.roomName || "Guest",
    description: snap?.content ?? latest?.content ?? "",
    attachment: snap?.file_image || latest?.file_image,
    time: msgTime(latestTime),
    startTime: formatChatStartedTime(newRoom.createdAt),
    deviceType: customerUser?.deviceType,
    os: customerUser?.os,
    is_unAssigned: true,
    is_archived: false,
    end_session: newRoom.end_session,
    unAssignedCount: newRoom.unAssignedMessageCount || 0,
    iso: latestTime,
    isLive: customerUser ? !!customerUser.socket_active : true,
    customerId: customerUser?._id || visitorIdFromIds || null,
    roomUsers:
      roomUserIds.length > 0
        ? roomUserIds
        : customerUser?._id
        ? [customerUser._id]
        : [],
    businessId: newRoom.business_id,
    assignedTo: newRoom.assigned_to,
    tags: newRoom.tags || [],
    is_guest: customerUser?.is_guest || false,
    readReceipt: getChatListReadReceiptFromRoom(newRoom, newRoom.unAssignedMessageCount || 0),
    sourceGroup: (() => {
      const g =
        newRoom.group_id && typeof newRoom.group_id === "object"
          ? newRoom.group_id
          : Array.isArray(newRoom.groups) && newRoom.groups[0]
            ? newRoom.groups[0]
            : null;
      if (!g || typeof g !== "object") return null;
      const name = g.name || g.title || "";
      if (!name && !(g._id || g.id)) return null;
      return {
        id: g._id || g.id || null,
        name: name || "Group",
        image: g.group_image || g.image || null,
      };
    })(),
  };
}
